import { useNavigate } from "react-router-dom"

const PaymentSuccess = () => {
    const navigate = useNavigate()
    return (
        <div className="result">
            <div className="container">
                <div className="result-main">
                    <div className="result-left">
                        <h2 className="caption-two result-title">Payment successful</h2>
                        <h4 className="result-description">
                            Your payment should be available.
                        </h4>
                        <button className="btn btn-dark result-button" onClick={() => navigate(`/`)}>
                            Done
                        </button>
                    </div>
                    <div className="result-right">
                        <img className="result-picture" src="../../../images/payment-successful.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentSuccess


